export const filterCanCreateVisitBehalf = member =>
  member.permissions?.requested_permissions.find(
    ({ desc, status }) =>
      desc === 'create_doctor_visit' && status === 'approved'
  )

export const filterActiveMembers = member => member.status !== 'pending'

export const filterActiveMembersWithPermissions = member =>
  member.status !== 'pending' &&
  !!member.permissions?.requested_permissions.length &&
  // check if one of the rqeuested permissions is not approved
  !member.permissions?.requested_permissions?.some(
    ({ status }) => status === 'denied' || status === 'requested'
  )

export const filterCanInviteToMyCall = member =>
  member.permissions?.granted_permissions?.find(
    ({ desc, status }) =>
      desc === 'participate_in_doctor_visit' && status === 'approved'
  )

export const filterCanViewMedicalRecords = member =>
  member.permissions?.requested_permissions?.find(
    ({ desc, status }) =>
      desc === 'view_medical_records' && status === 'approved'
  )

export const filterCanGrantPermissions = members =>
  members?.find(member => member.permissions?.granted_permissions?.length)

export const filterCanEditPersonalData = member =>
  member.permissions?.requested_permissions?.find(
    ({ desc, status }) => desc === 'edit_personal_data' && status === 'approved'
  )
